const socials = [
	{
		mediaLink: `https://www.linkedin.com/in/robin-wafula-95a09218a/`,
		classString: `fab fa-linkedin-in fa-customize`,
	},
	{
		mediaLink: `https://github.com/Robby-apt`,
		classString: `fab fa-github fa-customize`,
	},
];

export default socials;
